import { ApiSlugs, EmailId, EmailSummaryDto, ListPagination } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserRegistrationEmailsAdminConnector extends ApiConnector<
  EmailSummaryDto,
  EmailSummaryDto,
  EmailId
> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.EMAILS}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<EmailSummaryDto[]> =>
      this.apiCaller.getRequest<EmailSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
